import { render, staticRenderFns } from "./OrganisationBase.vue?vue&type=template&id=47e03c17&"
import script from "./OrganisationBase.vue?vue&type=script&lang=ts&"
export * from "./OrganisationBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports